module.exports = __webpack_public_path__ + "static/media/the_road_to_react2.a73ae587.md";